import { GroupTableType } from "helpers/models";

export default (
  tivTable: Record<string, GroupTableType>
): Record<string, string[]> => {
  const arr = ["Outside", "No Data", "Negligible", "No Observation"];
  const layersWithOnlySpecificLabels: Record<string, string[]> = {};

  for (const groupKey in tivTable) {
    if (Object.hasOwn(tivTable, groupKey)) {
      const layers = tivTable[groupKey];
      layersWithOnlySpecificLabels[groupKey] = [];
      for (const layerId in layers) {
        if (Object.hasOwn(layers, layerId)) {
          const layerData = layers[layerId];
          const allLabelsInArr = layerData.every((item) =>
            arr.includes(item.label)
          );
          if (allLabelsInArr) {
            layersWithOnlySpecificLabels[groupKey].push(layerId);
          }
        }
      }
    }
  }
  return layersWithOnlySpecificLabels;
};
